import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Button, Divider, Dialog, DialogContent, DialogActions } from '@material-ui/core';

// Services
import { deleteConsultingVisit } from 'services/requests';

// ----------------------------------------------------------------------------------------------- \\
// ----------------------------------- DELETE CONSULTING VISIT ----------------------------------- \\
// ----------------------------------------------------------------------------------------------- \\

const DeleteConsultingVisit = ({ onClose, consulting_visit, refetch }) => {
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading) {
            deleteConsultingVisit(consulting_visit.id).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    if (refetch) {
                        refetch();
                    }
                    else {
                        history.goBack();
                    }
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setLoading(false);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    return (
        <Dialog open>
            <DialogContent style={{ paddingBottom: 20 }}>
                <p className="dialog-title">
                    Supprimer la demande de visite-conseil
                </p>
                Êtes-vous sûr de vouloir supprimer cette demande ?
            </DialogContent>
            <Divider />
            <DialogActions style={{ justifyContent: 'space-between' }}>
                <Button onClick={onClose} variant="contained">
                    Non
                </Button>
                <Button onClick={() => setLoading(true)} variant="contained">
                    Oui
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConsultingVisit;
